import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    Injector,
    IterableDiffers,
    DoCheck,
} from "@angular/core";
import { TableAction } from "../../../../../../utils/types/shared/table-action";
import { BaseDataSource } from "../../../../../../utils/datasources/shared/base.datasource";
import { PropertyChange } from "../../../../../../utils/types/shared/property-change";
import { FormGroup } from "@angular/forms";
import { FormFieldConfig } from "../../models/form-field-config";
import { FieldError } from "../../models/field-error";
import { IFormField } from "../../interfaces/iform-field";
import { FormTableDataSource } from "./form-table-datasource";
import { FormComponent } from "../../form/form.component";
import { TableOptions } from "../../models/table-options";

@Component({
    selector: "app-form-table",
    templateUrl: "./form-table.component.html",
    styleUrls: ["./form-table.component.scss"],
    providers: [FormTableDataSource],
})
export class FormTableComponent implements OnInit, IFormField {
    dialogRef: any;
    selectedRecord: any;
    @Input() showAddButton: Boolean;
    @Output() booleanChangeEvent = new EventEmitter<PropertyChange>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() rowDoubleClick = new EventEmitter<any>();
    @Output() addButtonClickHandler = new EventEmitter<any>();

    propertyName: string;
    group: FormGroup;
    config: FormFieldConfig;
    model: any;
    formControl: FormComponent;
    errors = new Array<FieldError>();
    differ: any;
    isVisible = true;
    hidePaginator = false;
    datasource: FormTableDataSource<Object>;

    constructor(
        private injector: Injector,
        private _datasource: FormTableDataSource<Object>,
        private differs: IterableDiffers
    ) {
        this.datasource = _datasource;
        this.showAddButton = true;
    }

    ngOnInit() {
        this.resetDiffer();

        if (this.config.fieldInfo.options) {
            const options = <TableOptions>this.config.fieldInfo.options;

            if (options) {
                this.hidePaginator = options.hidePaginator;
            }
        }
    }

    ngDoCheck() {
        if (!this.differ) {
            return;
        }

        const changes = this.differ.diff(
            this.model[this.config.fieldInfo.name]
        );
        this.resetDiffer();

        if (changes) {
            this.registerChanges(this.model[this.config.fieldInfo.name]);
        }
    }

    registerChanges(records: Array<any>) {
        if (!records) {
            return;
        }

        this.datasource.setList(records);

        // records.forEach(item => {
        //   this.datasource.addNewRecord(item);
        // });
    }

    resetDiffer() {
        this.differ = this.differs
            .find(this.model[this.config.fieldInfo.name])
            .create();
    }

    tableInitialized() {
        const data = this.model[this.config.fieldInfo.name] as Array<any>;
        if (data && data.length > 0) {
            data.splice(0, 1);
        }
    }

    addNewRecord(data) {
        this.formControl.newRecordEventHandler();
    }

    setObservableDataSource(data: any) {}

    booleanPropertyChangedEvent(data) {
        this.booleanChangeEvent.emit(data);
    }

    rowDoubleClickEvent(data) {
        this.rowDoubleClick.emit(data);
    }

    rowClickEvent(data) {
        this.rowClick.emit(data);
    }

    getErrorList() {
        // const control = this.group.controls[this.config.fieldInfo.name];
        // this.errors.length = 0;

        // if (control.errors) {
        //   this.errors = FormUtils.getErrorRepresentation(control.errors);
        // }

        return this.errors;
    }

    onFocus(event) {
        if (this.errors) {
            this.errors.length = 0;
        }
    }

    onLostFocus(event) {
        this.getErrorList();
    }

    setVisible(isVisible: boolean) {
        this.isVisible = isVisible;
    }

    isControlVisible(): boolean {
        return this.isVisible;
    }

    processValueChanged(data: PropertyChange) {
        this.formControl.tablePropertyChanged.emit(data);
    }
}
